var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetApp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "get_app_svg__ds",
    x1: 147.05,
    y1: 179.44,
    x2: 283.97,
    y2: 179.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "get_app_svg__av"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 442,
    height: 442,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 430,
    height: 430,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "get_app_svg__dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.98,260.2c-7.16,0-12.99,5.82-13,12.98l-.07,44.74c-.02,14.15,5.48,27.46,15.48,37.48,10,10.02,23.31,15.54,37.46,15.54h240.12c29.21,0,53.01-23.77,53.05-52.98l.06-43.05c0-3.47-1.34-6.74-3.79-9.2-2.45-2.46-5.72-3.82-9.21-3.82-7.16,0-12.99,5.82-13,12.98l-.06,43.05c-.02,14.9-12.16,27.02-27.05,27.02H94.86c-7.2,0-13.97-2.81-19.06-7.91-5.09-5.1-7.89-11.87-7.88-19.07l.07-44.73c.01-7.17-5.81-13.01-13-13.02Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.41,296.13c2.38,2.38,5.55,3.7,8.92,3.7s6.54-1.31,8.92-3.7l56.02-56.02c4.92-4.92,4.92-12.93,0-17.85-2.38-2.38-5.55-3.7-8.92-3.7s-6.54,1.31-8.92,3.7l-34.46,34.45V71.68c0-6.96-5.66-12.62-12.62-12.62s-12.62,5.66-12.62,12.62v185.08l-34.15-34.16c-2.38-2.38-5.55-3.7-8.92-3.7s-6.54,1.31-8.92,3.7c-4.92,4.92-4.92,12.93,0,17.85l55.67,55.68Z",
    style: {
      fill: "url(#get_app_svg__ds)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetApp);
export default __webpack_public_path__ + "static/media/get_app.14062a221e1c4643550f37d48b3b981f.svg";
export { ForwardRef as ReactComponent };